import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { getLastCompleteSurveyResponse } from 'services/reports';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';

const LastCompletedResponse = ({ surveyId, ...rest }) => {
  const [lastResponse, setLastResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchLastResponse = async () => {
    if (!surveyId || surveyId === 0) {
      setLastResponse(null);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getLastCompleteSurveyResponse(surveyId);
      console.log('getLastCompleteSurveyResponse', response);
      if (response.result && response.last_response) {
        console.log('(response.result && response.last_response)');
        if (response.last_response.created_at) {
          console.log('if (response.last_response.completed_at) {');
          setLastResponse(response.last_response);
        } else {
          setLastResponse(null);
          setError('La última respuesta no está completada');
        }
      } else {
        setLastResponse(null);
        setError('No hay respuestas completadas');
      }
    } catch (err) {
      console.error('Error al obtener la última respuesta:', err);
      setError('Error al cargar datos');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLastResponse();
  }, [surveyId]);
  return (
    <Card {...rest} className="h-100">
      <FalconCardHeader
        title="Última Respuesta Recibida"
        light={false}
        titleTag="h5"
        className="pb-0"
      />
      <Card.Body className="pt-2">
        {!surveyId || surveyId === 0 ? (
          <div className="text-center py-3 text-muted">
            Selecciona una encuesta para ver los datos.
          </div>
        ) : loading ? (
          <div className="text-center py-3">
            <Spinner animation="border" size="sm" className="me-2" />
            <span className="text-muted">Cargando...</span>
          </div>
        ) : error ? (
          <div className="text-center py-3 text-muted">
            <FontAwesomeIcon icon={faClock} className="me-2" />
            {error}
          </div>
        ) : lastResponse ? (
          <Row className="  align-items-center justify-content-center">
            <Col xs={12} className="text-center">
              <div className=" text text-600">
                <FontAwesomeIcon icon={faClock} className="me-2" />
                {lastResponse.created_at}
              </div>
            </Col>
          </Row>
        ) : (
          <div className="text-center py-3 text-muted">
            <FontAwesomeIcon icon={faClock} className="me-2" />
            No hay respuestas completadas
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

LastCompletedResponse.propTypes = {
  surveyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
};

LastCompletedResponse.defaultProps = {
  surveyId: null
};

export default LastCompletedResponse;
